var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightArrowPurple = function SvgRightArrowPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7484FF",
    fillRule: "evenodd",
    d: "M6 12a.9.9 0 0 1 .9-.9h7.966l-2.59-2.351a.9.9 0 1 1 1.248-1.298l4.2 3.9a.9.9 0 0 1 0 1.298l-4.2 3.9a.9.9 0 0 1-1.248-1.298l2.59-2.351H6.9A.9.9 0 0 1 6 12Z",
    clipRule: "evenodd"
  })));
};
export default SvgRightArrowPurple;